import { RootState } from '@/store';
import { State } from './state';
import { ActionTree } from 'vuex';

import {
    FETCH_PROFILE_LIST,
    CREATE_PROFILE_LIST,
    SET_PROFILE_LIST,
    UPDATE_REGISTER_PROFILE_FORM_VISIBILITY,
    SET_REGISTER_PROFILE_FORM_VISIBILITY,
    UPDATE_SELECTED_PROFILE,
    SET_SELECTED_PROFILE,
    CREATE_NEW_PROFILE,
    UPDATE_PROFILE_LIST,
    UPDATE_PROFILE,
    ADD_PROFILE_TO_LIST,
    FETCH_FLAG_LIST,
    SET_FLAG_LIST,
    FETCH_VEHICLE_TYPE_LIST,
    SET_VEHICLE_TYPE_LIST,
    FETCH_COUNTRY_LIST,
    SET_COUNTRY_LIST,
    FETCH_PROFILE_FUNCTIONALITIES,
    SET_PROFILE_FUNCTIONALITIES,
    UPDATE_SELECTED_PROFILE_FUNCTIONALITIES,
    UPDATE_CURRENT_PROFILE_TAB,
    SET_CURRENT_PROFILE_TAB,
    FETCH_PROFILE_FUNCTIONALITIES_REPORT,

} from './types';
import { profileApi } from '@/api/profile.api';
import { flagApi } from '@/api/flag.api';
import { countryApi } from '@/api/country.api';
import { vehicleApi } from '@/api/vehicle.api';
import { IProfile } from '@/modules/profile/models';
import { IFunctionality } from '@/modules/functionality/models';
import { MessageService } from '@/services/messageService';


export const actions: ActionTree<State, RootState> = {
    async [FETCH_PROFILE_LIST]({ commit }, isOnlyActive: boolean) {
        return  profileApi.getAll(isOnlyActive).catch((error: any) => {MessageService.Error('Erro', error); } );
    },
    async [CREATE_PROFILE_LIST]({commit}, payload: State) {
        commit(SET_PROFILE_LIST, payload);
    },
    async [UPDATE_REGISTER_PROFILE_FORM_VISIBILITY]({ commit }, payload: boolean) {
        commit(SET_REGISTER_PROFILE_FORM_VISIBILITY, payload);
    },
    async [UPDATE_SELECTED_PROFILE]({ commit }, payload: State) {
        commit(SET_SELECTED_PROFILE, payload);
    },
    async [UPDATE_PROFILE_LIST]({ commit }, payload: IProfile) {
        commit(ADD_PROFILE_TO_LIST, payload);
    },
    async [CREATE_NEW_PROFILE]({ commit }, payload: IProfile) {
        return profileApi.addProfile(payload).catch((error: any) => {MessageService.Error('Erro', error); } );
    },
    async [UPDATE_PROFILE]({ commit }, payload: IProfile) {
        return profileApi.updateProfile(payload).catch((error: any) => {MessageService.Error('Erro', error); } );
    },
    async [FETCH_FLAG_LIST]({ commit }, payload: State) {
        commit(SET_FLAG_LIST, (await flagApi.getAll()).data);
    },
    async [FETCH_COUNTRY_LIST]({ commit }, payload: State) {
        commit(SET_COUNTRY_LIST, (await countryApi.getAll()).data);
    },
    async [FETCH_VEHICLE_TYPE_LIST]({ commit }, payload: State) {
        commit(SET_VEHICLE_TYPE_LIST, (await vehicleApi.getAll()).data);
    },
    async [FETCH_PROFILE_FUNCTIONALITIES]({ commit }, payload: number) {
        return profileApi.getProfileFunctionalities(payload).catch((error: any) => {MessageService.Error('Erro', error); } );
    },
    async [UPDATE_SELECTED_PROFILE_FUNCTIONALITIES]({ commit }, payload: IFunctionality[]) {
        commit(SET_PROFILE_FUNCTIONALITIES, payload);
    },
    async [UPDATE_CURRENT_PROFILE_TAB]({ commit }, payload: string) {
        commit(SET_CURRENT_PROFILE_TAB, payload);
    },
    async [FETCH_PROFILE_FUNCTIONALITIES_REPORT]({ commit }, isOnlyActive: boolean) {
        return profileApi.getProfileFunctionalitiesReport(isOnlyActive);
    },

};
